import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';

import { getDeveloper } from '../../selectors/developerV2';
import { trackShowPhone } from '../ContactButtonsRedesigned/tracking';
import { getPhoneLabel, getSinglePhone, getSingleSiteBlockId } from './utils/phone';
import { useContacts } from '../Call/useContacts';
import { useDynamicCalltracking } from './hooks/useDynamicCalltracking';
import { MobileCallButtonLayout } from '../../components/MobileCallButtonLayout';

const CALL_BUTTON_PLACE_TYPE = 'developerCardContacts';

export function MobileCall() {
  const developer = useSelector(getDeveloper);

  const onShowPhone = React.useCallback((developerId: number) => {
    trackShowPhone('Open_card_builder')(developerId);
  }, []);

  const { builders, sellers } = useContacts();

  const handleShowPhone = React.useCallback(() => {
    onShowPhone(developer.id);
  }, [developer, onShowPhone]);

  const singlePhone = React.useMemo(() => {
    return getSinglePhone(builders, sellers);
  }, [builders, sellers]);
  const singleSiteBlockId = React.useMemo(() => {
    return getSingleSiteBlockId(builders, sellers);
  }, [builders, sellers]);
  const singlePhoneLabel = React.useMemo(() => {
    return getPhoneLabel(builders, sellers);
  }, [sellers, builders]);

  const handleClick = useDynamicCalltracking({
    phone: singlePhone,
    placeType: CALL_BUTTON_PLACE_TYPE,
    siteBlockId: singleSiteBlockId,
    onClick: handleShowPhone,
  });

  return (
    <MobileCallButtonLayout data-testid={`CallButtonContent-${CALL_BUTTON_PLACE_TYPE}`}>
      <Button
        size="L"
        beforeIcon={<IconCommunicationPhone16 color="current_color" />}
        fullWidth={true}
        data-testid="CallText"
        onClick={handleClick}
      >
        {singlePhoneLabel}
      </Button>
    </MobileCallButtonLayout>
  );
}
